import { t } from "i18next";

export const typesPrestation = child => {
  let types = [
    {
      label: t("typesPrestation.formation.label"),
      key: "typesPrestation.formation.label",
      value: "typesPrestation.formation.label",
      options: [
        // {
        //   label: t("typesPrestation.formation.prescolaire"),
        //   value: "typesPrestation.formation.prescolaire",
        // },
        {
          label: t("typesPrestation.formation.primaire"),
          value: "typesPrestation.formation.primaire",
        },
        {
          label: t("typesPrestation.formation.secondaireI"),
          value: "typesPrestation.formation.secondaireI",
        },
        {
          label: t("typesPrestation.formation.secondaireII"),
          value: "typesPrestation.formation.secondaireII",
        },
        // {
        //   label: t("typesPrestation.formation.orientationPro"),
        //   value: "typesPrestation.formation.orientationPro",
        // },
        {
          label: t("typesPrestation.formation.enseignementSpecialise"),
          value: "typesPrestation.formation.enseignementSpecialise",
        },
        // {
        //   label: t("typesPrestation.formation.servicesPsychosociaux"),
        //   value: "typesPrestation.formation.servicesPsychosociaux",
        // },
        {
          label: t("typesPrestation.formation.autresFormation"),
          value: "typesPrestation.formation.autresFormation",
        },
      ],
    },
    {
      label: t("typesPrestation.sante.label"),
      key: "typesPrestation.sante.label",
      value: "typesPrestation.sante.label",
      options: [
        {
          label: t("typesPrestation.sante.hopital"),
          value: "typesPrestation.sante.hopital",
        },
        // {
        //   label: t("typesPrestation.sante.hopitalAmbulatoire"),
        //   value: "typesPrestation.sante.hopitalAmbulatoire",
        // },
        // {
        //   label: t("typesPrestation.sante.cabinetMedical"),
        //   value: "typesPrestation.sante.cabinetMedical",
        // },
        {
          label: t("typesPrestation.sante.psy"),
          value: "typesPrestation.sante.psy",
        },
        // {
        //   label: t("typesPrestation.sante.psyAmbulatoire"),
        //   value: "typesPrestation.sante.psyAmbulatoire",
        // },
        // {
        //   label: t("typesPrestation.sante.readaptation"),
        //   value: "typesPrestation.sante.readaptation",
        // },
        // {
        //   label: t("typesPrestation.sante.expertise"),
        //   value: "typesPrestation.sante.expertise",
        // },
        // {
        //   label: t("typesPrestation.sante.conseilPrevention"),
        //   value: "typesPrestation.sante.conseilPrevention",
        // },
        {
          label: t("typesPrestation.sante.autresSante"),
          value: "typesPrestation.sante.autresSante",
        },
      ],
    },
    {
      label: t("typesPrestation.social.label"),
      value: "typesPrestation.social.label",
      key: "typesPrestation.social.label",
      options: [
        {
          label: t("typesPrestation.social.aideSociale"),
          value: "typesPrestation.social.aideSociale",
        },
        // {
        //   label: t("typesPrestation.social.orp"),
        //   value: "typesPrestation.social.orp",
        // },

        {
          label: t("typesPrestation.social.protectionEnfantAdulte"),
          value: "typesPrestation.social.protectionEnfantAdulte",
        },
        // {
        //   label: t("typesPrestation.social.serviceConsultation"),
        //   value: "typesPrestation.social.serviceConsultation",
        // },
        // {
        //   label: t("typesPrestation.social.etatCivil"),
        //   value: "typesPrestation.social.etatCivil",
        // },
        {
          label: t("typesPrestation.social.autoriteOffice"),
          value: "typesPrestation.social.autoriteOffice",
        },
        {
          label: t("typesPrestation.social.autresSocial"),
          value: "typesPrestation.social.autresSocial",
        },
      ],
    },
    // {
    //   label: t("typesPrestation.asile.label"),
    //   value: "typesPrestation.asile.label",
    //   key: "typesPrestation.asile.label",
    //   options: [
    //     {
    //       label: t("typesPrestation.asile.representationJuridique"),
    //       value: "typesPrestation.asile.representationJuridique",
    //     },
    //     {
    //       label: t("typesPrestation.asile.consultationProcedure"),
    //       value: "typesPrestation.asile.consultationProcedure",
    //     },
    //     {
    //       label: t("typesPrestation.asile.conseilRetour"),
    //       value: "typesPrestation.asile.conseilRetour",
    //     },
    //     {
    //       label: t("typesPrestation.asile.soinsCentreFederal"),
    //       value: "typesPrestation.asile.soinsCentreFederal",
    //     },
    //     {
    //       label: t("typesPrestation.asile.soinsCentreCantonal"),
    //       value: "typesPrestation.asile.soinsCentreCantonal",
    //     },
    //     {
    //       label: t("typesPrestation.asile.conseil"),
    //       value: "typesPrestation.asile.conseil",
    //     },
    //     {
    //       label: t("typesPrestation.asile.autresAsile"),
    //       value: "typesPrestation.asile.autresAsile",
    //     },
    //   ],
    // },
    {
      label: t("typesPrestation.autoritesTribunaux.label"),
      value: "typesPrestation.autoritesTribunaux.label",
      key: "typesPrestation.autoritesTribunaux.label",
      options: [
        {
          label: t("typesPrestation.autoritesTribunaux.justice"),
          value: "typesPrestation.autoritesTribunaux.justice",
        },
        // {
        //   label: t("typesPrestation.autoritesTribunaux.police"),
        //   value: "typesPrestation.autoritesTribunaux.police",
        // },
        {
          label: t("typesPrestation.autoritesTribunaux.autresAutorites"),
          value: "typesPrestation.autoritesTribunaux.autresAutorites",
        },
      ],
    },
  ];

  if (child === undefined) {
    return types;
  } else {
    let type = types.find(type => type.key === child);
    if (type === undefined) {
      return [];
    } else {
      return type.options;
    }
  }
};
export const mainTypesPrestation = [
  {
    label: "Formation",
    value: "Formation",
  },
  {
    label: "Santé",
    value: "Santé",
  },
  {
    label: "Social",
    value: "Social",
  },
  {
    label: "Asile",
    value: "Asile",
  },
  {
    label: "Autorités et tribunaux",
    value: "Autorités et tribunaux",
  },
];
